import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import useInbox from "../../InboxTab/InboxContext";
import EmailDetailsStructure from "../EmailsDetailsView/EmailDetailsStructure";
import EmailsList from "./EmailsList";
import EmailHistoryModalLayout from "../../EmailModalLayout/EmailHistoryModalLayout";

export default function EmailListStructure({ searchQuery }) {
  /* ******************** All States ************************* */
  const {
    messageId,
    setMessageId,
    fromEmail,
    setFromEmail,
    emailsHistoryList,
    setEmailsHistoryList,
  } = useInbox();

  const [showEmailsListModal, setShowEmailsListModal] = useState(false);

  /* ******************** All Functions ************************* */

  const hideModal = () => {
    setMessageId(null);
    setFromEmail(null);
    setEmailsHistoryList([]);
  };

  /* ******************** All UseEffects ************************* */
  useEffect(() => {
    if (fromEmail) {
      setShowEmailsListModal(true);
    } else {
      setShowEmailsListModal(false);
      setFromEmail(null);
    }
  }, [fromEmail]);

  return (
    <div className="flex-grow-1">
      {messageId ?
        <main className="flex-grow-1 px-3 py-2">
          <div
            className="card custom-border-radius p-2"
            style={{
              height: "98vh",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <EmailDetailsStructure />
          </div>
        </main>
      : <EmailsList searchQuery={searchQuery} />}
      {/* ******************** Email History Modal ************************* */}
      <style>
        {`
        .custom-modal-width {
          max-width: 95vw;
          height: 90vh;
          // margin-left: auto;
          margin-right: auto;
        }
      `}
      </style>

      <Modal
        show={showEmailsListModal}
        onHide={() => hideModal()}
        dialogClassName="custom-modal-width"
        style={{
          zIndex: 99999,
        }}
      >
        <div className="bg-light custom-border-radius">
          {fromEmail && <EmailHistoryModalLayout hideModal={hideModal} />}
        </div>
      </Modal>
    </div>
  );
}
